import React, { useEffect } from 'react';
import { useState } from 'react';

import t from '../Translation/Translation';
import { IonButtons, IonContent, IonHeader, IonFooter, IonPage, IonTitle, IonToolbar, IonMenuToggle, IonModal, IonButton, IonIcon, IonLabel } from '@ionic/react';
import { useIonViewWillEnter, useIonViewDidEnter, useIonViewWillLeave } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Avatar, Loader, CustomTable } from 'citric_components';
import Menubar from '../Dashboard/Menubar';
import { App } from '@capacitor/app';

import CardImg from '../../images/card.png';
import { useNavigate } from 'react-router';

import conf from '../../config.json';
import { formatDate, logD } from '../Util/Util';
import i18next from 'i18next';

export default function ReleasesAdmContent(props) {
    logD("ReleasesAdmContent", props);
    const launchs = props.releases;
    //const [launchs, setLaunchs] = useState(props.releases);
    /*const project = props.project;
    const projects = props.projects;*/
    const [showLoader, setShowLoader] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const [summaries, setSummaries] = useState([]);

    const navigate = useNavigate();

    function showOutputs(item) {
        console.log(item);
        setSelected(item);
        setTimeout(function(){
            setModalOpen(true);
        }, 100);
    }

    const columnsOutput = [
        {
            Header: t('id'),
            accessor: 'idOutput',
        },
        {
            Header: t('actions'),
            id: 'actions',
            accessor: (d) => {
                return <>
                    <IonButton color="primary" onClick={(e) => {
                            e.preventDefault();
                            const url = conf.Tprotocol + '://' + conf.Thost + ':' + conf.Tport + '/' + conf.BEcontext + '/jobs/export?idExport=' + d.idOutput + '&force=true';
                            fetch(url, {
                                method: 'GET',
                            })
                            .then((response) => props.handleError(response))
                            .then((data) => {
                                logD("Send export", data);
                            }).catch((e) => {
                                props.setShowToast(true);
                            });
                        }
                    }>
                        {t('send')}
                    </IonButton>
                    <IonButton color="primary" onClick={(e) => {
                            e.preventDefault();
                            setShowLoader(true);
                            const url = conf.Tprotocol + '://' + conf.Thost + ':' + conf.Tport + '/' + conf.BEcontext + '/jobs/export?idExport=' + d.idOutput + '&force=true&download=true';
                            fetch(url, {
                                method: 'GET',
                            })
                            .then( res => res.blob() )
                            .then( async blob => {
                                /*var file = window.URL.createObjectURL(blob);
                                window.location.assign(file);*/
                                const fileContents = await blob;
                                const a = document.createElement("a");
                                const url = URL.createObjectURL(fileContents);
                                const format = (d.format === 'spss') ? 'sav' : d.format;
                                a.href = url;
                                a.download = d.name + '_' + formatDate(new Date()) + '.' + format;
                                a.click();
                                URL.revokeObjectURL(url);
                                setShowLoader(false);
                            })
                            .catch((e) => {
                                props.setShowToast(true);
                            });
                        }
                    }>
                        {t('download')}
                    </IonButton>
                </>
            }
        },
        {
            Header: t('name'),
            accessor: 'name',
        },
        {
            Header: t('mail'),
            accessor: 'mail',
        },
        {
            Header: t('format'),
            accessor: 'format',
        },
        {
            Header: t('scheduled'),
            id: 'scheduled',
            accessor: (d) => {
                return d.cron != null && d.cron.length > 0 ? t('true') : t('false');
            }
        },
    ];

    const columns = [
        {
            Header: t('id'),
            accessor: 'idDraft',
        },
        {
            Header: t('actions'),
            id: 'actions',
            accessor: (d) => {
                return <>
                   <IonButton color="primary" onClick={(e) => {
                            e.preventDefault();
                            props.loadRelease(d);
                        }
                    }>
                        {t('load')}
                    </IonButton>
                    <IonButton color="secondary" onClick={(e) => {
                            e.preventDefault();
                            props.setUrl(conf.BEprotocol + '://' + conf.Thost + ':' + conf.Tport + '/' + conf.Tcontext + '?project=' + props.project.idProject + '&sv=' + d.idDraft + '&qa=1&nomb=1');
                            props.setTitle(t('tracking'));
                            props.setTypeUrl('tracking');
                            setTimeout(function(){
                                navigate('../webview/'+d.idDraft);
                            }, 100);
                        }
                    }>{t('tracking')}</IonButton>

                    { (props.token.r == 1 || (props.token.r == 2 && props.userConfig != null && props.userConfig.outputs)) && d.outputs != null && <IonButton color="tertiary" onClick={(e) => {
                            e.preventDefault();
                            showOutputs(d);
                        }
                    }>{t('outputs')}</IonButton>}
                </>
            }
        },
        {
            Header: t('code'),
            accessor: 'code',
        },
        {
            Header: t('name'),
            accessor: 'name',
        },
        {
            Header: t('desc'),
            accessor: 'desc',
        },
        {
            Header: t('access'),
            id: 'AC',
            accessor: (d) => {
                if(d.summary) {
                    return d.summary.access
                }
                return 0;
            }
        },
        {
            Header: t('complete'),
            id: 'F',
            accessor: (d) => {
                if(d.summary) {
                    return d.summary.complete
                }
                return 0;
            }
        }, {
            Header: t('dropout'),
            id: 'A',
            accessor: (d) => {
                if(d.summary) {
                    return d.summary.dropout
                }
                return 0;
            }
        }, {
            Header: t('screenout'),
            id: 'D',
            accessor: (d) => {
                if(d.summary) {
                    return d.summary.screenout
                }
                return 0;
            }
        }, {
            Header: t('quotafull'),
            id: 'DC',
            accessor: (d) => {
                if(d.summary) {
                    return d.summary.quotafull
                }
                return 0;
            }
        }
    ];

    var hiddenColumns = [];
    
    return (
        <>
            {launchs == null && <Loader />}
            {
                launchs != null &&
                <CustomTable keyField='id' desc={false} data={launchs} columns={columns} isFilter={true} isPagination={true} isSelection={false} hasActions={false} hiddenColumns={hiddenColumns} isExport={true}/>
            }
            <IonModal className="big-modal" isOpen={modalOpen}>
                <IonHeader>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonButton onClick={() => setModalOpen(false)}>{t('close')}</IonButton>
                        </IonButtons>
                        <IonTitle>{t('outputs')}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    {
                        showLoader && <Loader />    
                    }
                    {   selected != null && selected.outputs != null &&
                        <CustomTable keyField='idOutput' desc={false} data={selected.outputs} columns={columnsOutput} isFilter={true} isPagination={true} isSelection={false} hasActions={false} hiddenColumns={hiddenColumns} isExport={true}/>
                    }
                </IonContent>
            </IonModal>
        </>
    );
}